import request from '@/config/axios';

/** 景区优惠券模板分页 */
export const getScenicCouponPage = (params: any) => request.get({ url: '/scenic/coupon/page', params });

/** 保存景区优惠券模板 */
export const saveScenicCoupon = (data: any) => request.post({ url: '/scenic/coupon/save', data });

/** 删除景区优惠券模板 */
export const deleteScenicCoupon = (id: number) => request.delete({ url: '/scenic/coupon/delete', params: { id } });

/** 用户领取记录分页 */
export const getScenicUserCouponPage = (params: any) => request.get({ url: '/scenic/coupon/user/page', params });
